export default "__VITE_ASSET__DKXMYhVq__"